import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-300px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = { class: "symbol symbol-50px me-5" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_10 = { class: "menu-item px-5" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" My Profile ")
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  class: "menu-item px-5",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "bottom"
}
const _hoisted_14 = {
  class: "menu-link px-5",
  href: "#"
}
const _hoisted_15 = { class: "menu-title position-relative" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Language ")
const _hoisted_17 = { class: "fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "menu-sub menu-sub-dropdown w-175px py-4" }
const _hoisted_20 = { class: "menu-item px-3" }
const _hoisted_21 = { class: "symbol symbol-20px me-4" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" English ")
const _hoisted_24 = { class: "menu-item px-3" }
const _hoisted_25 = { class: "symbol symbol-20px me-4" }
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Chinese ")
const _hoisted_28 = { class: "menu-item px-3" }
const _hoisted_29 = { class: "symbol symbol-20px me-4" }
const _hoisted_30 = ["src"]
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" German ")
const _hoisted_32 = {
  key: 0,
  class: "menu-item px-5",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "bottom"
}
const _hoisted_33 = {
  class: "menu-link px-5",
  href: "#"
}
const _hoisted_34 = { class: "menu-title position-relative" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Warehouse ")
const _hoisted_36 = { class: "fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0" }
const _hoisted_37 = { class: "menu-sub menu-sub-dropdown w-200px py-4" }
const _hoisted_38 = { class: "menu-item px-3" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "menu-item px-5 my-1" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Account Settings ")
const _hoisted_42 = ["href"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_44 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            alt: "Logo",
            src: require('../../../assets/media/avatars/blank.png')
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.userInfo.firstname) + " " + _toDisplayString(_ctx.userInfo.lastname), 1),
          _createElementVNode("a", {
            href: 'mailto:' + _ctx.userInfo.email,
            class: "fw-bold text-muted text-hover-primary fs-7"
          }, _toDisplayString(_ctx.userInfo.email), 9, _hoisted_8)
        ])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      (_ctx.isCurrentSystem('base'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: '/profile/overview',
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "menu-link px-5",
            href: _ctx.baseUrl + '/#/profile/overview'
          }, "My Profile", 8, _hoisted_12))
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("a", _hoisted_14, [
        _createElementVNode("span", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("span", _hoisted_17, [
            _createTextVNode(_toDisplayString(_ctx.currentLangugeLocale.name) + " ", 1),
            _createElementVNode("img", {
              class: "w-15px h-15px rounded-1 ms-2",
              src: _ctx.currentLangugeLocale.flag,
              alt: "metronic"
            }, null, 8, _hoisted_18)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.setLang('en_US')), ["prevent"])),
            href: "#",
            class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('en_US') }])
          }, [
            _createElementVNode("span", _hoisted_21, [
              _createElementVNode("img", {
                class: "rounded-1",
                src: require('../../../assets/media/flags/united-states.svg'),
                alt: "metronic"
              }, null, 8, _hoisted_22)
            ]),
            _hoisted_23
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.setLang('zh_CN')), ["prevent"])),
            href: "#",
            class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('zh_CN') }])
          }, [
            _createElementVNode("span", _hoisted_25, [
              _createElementVNode("img", {
                class: "rounded-1",
                src: require('../../../assets/media/flags/china.svg'),
                alt: "metronic"
              }, null, 8, _hoisted_26)
            ]),
            _hoisted_27
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.setLang('de_DE')), ["prevent"])),
            href: "#",
            class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('de_DE') }])
          }, [
            _createElementVNode("span", _hoisted_29, [
              _createElementVNode("img", {
                class: "rounded-1",
                src: require('../../../assets/media/flags/germany.svg'),
                alt: "metronic"
              }, null, 8, _hoisted_30)
            ]),
            _hoisted_31
          ], 2)
        ])
      ])
    ]),
    (_ctx.isCurrentSystem('fulfillment') && _ctx.userInfo?.user_type === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("a", _hoisted_33, [
            _createElementVNode("span", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.getCurrentWarehouseName), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("a", {
                  onClick: _withModifiers(($event: any) => (_ctx.setWarehouse(item.value)), ["prevent"]),
                  href: "#",
                  class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentWarehouse(item.value) }])
                }, _toDisplayString(item.label), 11, _hoisted_39)
              ]))
            }), 256))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_40, [
      (_ctx.isCurrentSystem('base'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: '/profile/settings',
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _hoisted_41
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "menu-link px-5",
            href: _ctx.baseUrl + '/#/profile/settings'
          }, "Account Settings", 8, _hoisted_42))
    ]),
    _hoisted_43,
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("a", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5 text-danger"
      }, " Sign Out ")
    ])
  ]))
}